import { apiGet, apiPut, apiPost, apiDelete } from "./client";

export interface SearchProviderConfig {
  providerId: string;
  name: string;
  enabled: boolean;
  apiKey?: string;
  createdAt: string;
  updatedAt: string;
}

export async function listSearchProviders(): Promise<SearchProviderConfig[]> {
  const res = await apiGet<{ providers: SearchProviderConfig[] }>(
    "/api/search-providers",
  );
  return res.providers ?? [];
}

export async function updateSearchProvider(
  id: string,
  updates: Partial<SearchProviderConfig>,
): Promise<SearchProviderConfig> {
  const res = await apiPut<{ provider: SearchProviderConfig }>(
    `/api/search-providers/${id}`,
    updates,
  );
  return res.provider;
}

export async function testSearchProvider(
  id: string,
  config?: { apiKey?: string },
): Promise<{ success: boolean; response: string }> {
  return apiPost<{ success: boolean; response: string }>(
    `/api/search-providers/${id}/test`,
    config ?? {},
  );
}

export async function deleteSearchProvider(id: string): Promise<void> {
  await apiDelete(`/api/search-providers/${id}`);
}
